if (process.env.NODE_ENV === 'development') {
  module.exports = require('./dev')
} else {
  module.exports = require('./prod')
}



// WEBPACK FOOTER //
// ./src/i18n/index.js